import { FC } from 'react';

import { Panel } from '../PanelLayout';
import { PanelTemplateProps } from '../types';

const BodyPanel: FC<PanelTemplateProps> = ({
  children,
  name,
  ...otherProps
}) => {
  return (
    <Panel name={name || 'body'} {...otherProps}>
      {children}
    </Panel>
  );
};

export default BodyPanel;
